import { render, staticRenderFns } from "./SelectedRouteTable.vue?vue&type=template&id=64964f56&scoped=true"
import script from "./SelectedRouteTable.vue?vue&type=script&lang=js"
export * from "./SelectedRouteTable.vue?vue&type=script&lang=js"
import style0 from "./SelectedRouteTable.vue?vue&type=style&index=0&id=64964f56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64964f56",
  null
  
)

export default component.exports